var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252 29 227 4l-99 99L29 4 4 29l99 99-99 99 25 25 99-99 99 99 25-25-99-99z"
  })));
};
export default SvgClose;